import { compact } from 'lodash';

export default angular
  .module('st.Integrations.NZBNLookup', [])
  .service('NZBNLookupService', ($http, dataService, NZBNLOOKUP) => ({
    byName: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        NZBNLOOKUP.API.NZBN_LOOKUP_BY_NAME,
        params
      ),
    byNZBN: (params) =>
      dataService
        .apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          NZBNLOOKUP.API.NZBN_LOOKUP_BY_NZBN,
          params
        )
        .then((res) => compact([].concat(res)))
  }))
  .constant('NZBNLOOKUP', {
    API: {
      NZBN_LOOKUP_BY_NAME: '/api/v1/integration/nzbnLookup/name',
      NZBN_LOOKUP_BY_NZBN: '/api/v1/integration/nzbnLookup/nzbn'
    }
  });
